import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=157b37fc"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157b37fc')) {
      api.createRecord('157b37fc', component.options)
    } else {
      api.reload('157b37fc', component.options)
    }
    module.hot.accept("./ModelList.vue?vue&type=template&id=157b37fc", function () {
      api.rerender('157b37fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/ModelList.vue"
export default component.exports